import React, { Component } from "react";
import { Fade } from "react-awesome-reveal";

class About extends Component {
  render() {
    if (this.props.sharedBasicInfo) {
      var profilepic = "images/" + this.props.sharedBasicInfo.image;
    }
    if (this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.about;
      var hello = this.props.resumeBasicInfo.description_header;
      var about = this.props.resumeBasicInfo.description;
      var about_1 = this.props.resumeBasicInfo.description_1;
      var about_2 = this.props.resumeBasicInfo.description_2;
      var cv = this.props.resumeBasicInfo.cv_btn;
    }

    const handleDownload = () => {
      const link = document.createElement('a');
      link.href = process.env.PUBLIC_URL + '/cv/cv_jules_etourneau.pdf';
      link.download = 'cv_jules_etourneau.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    return (
      <section id="about">
        <div className="section-one">
          <Fade triggerOnce={true} duration={1500} direction="up">
            <div className="col-md-12">
              <div className="section-title" style={{ color: "black" }}>
                <h1 className="text-white">{sectionName}</h1>
              </div>
              <div className="row center about-content">
                <div className="col-lg-6 mb-5 center">
                  <div className="polaroid">
                    <img
                      src={profilepic}
                      alt="Avatar placeholder"
                    />
                  </div>
                </div>

                <div className="col-lg-6 center about-text">
                  <div className="col-md-10">
                    <div className="text-container">
                      <div className="text-item">
                          <br />
                          <span className="wave">{hello}</span>
                          <br />
                          <br />
                          {about}
                          <br />
                          {about_1}
                          <br />
                          <div dangerouslySetInnerHTML={{ __html: about_2 }} />
                      </div>
                    </div>
                    <div className="btn-container row center">
                  
                      <button target='_blank' className=" btn-action-pf btn-primary-pf" onClick={handleDownload}>{cv}</button>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
          <div className="separator">
            <svg className="separator__svg" width="100%" height="400" viewBox="0 0 100 100" preserveAspectRatio="none" fill="#ffe13a" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <path d="M 100 100 V 10 L 0 100" />
              <path d="M 30 73 L 100 18 V 10 Z" fill="#F5D000" strokeWidth="0" />
            </svg>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
